import React from 'react';
import CircleBlockedIcon from 'assets/svg/circle-blocked.svg';
import { useLocale } from 'locale';
import { NoAdSubtitle, NoAdTitle, NoAdWrapper, CircleBlockedIconWrapper } from './styled';

const NoListingMessage = () => {
  const { t } = useLocale();

  return (
    <NoAdWrapper>
      <CircleBlockedIconWrapper>
        <CircleBlockedIcon />
      </CircleBlockedIconWrapper>
      <div>
        <NoAdTitle>{t('searchListView.removedAd.title')}</NoAdTitle>
        <NoAdSubtitle>{t('searchListView.removedAd.subtitle')}</NoAdSubtitle>
      </div>
    </NoAdWrapper>
  );
};

export default NoListingMessage;
